import { Component, ViewEncapsulation, output, input } from '@angular/core';

import { ApContentPipe } from '@ap/content';

import { NavigationItem, NavigationType } from '../header.model';
import { SlideInOutLeftAnimation, SlideInOutRightAnimation } from '../header.component.animations';

import { ApVerticalNavigationItemComponent } from './vertical-navigation-item/vertical-navigation-item.component';
import { ApVerticalSubmenuComponent } from './vertical-submenu/vertical-submenu.component';

@Component({
    selector: 'ap-vertical-menu',
    templateUrl: './vertical-menu.component.html',
    styleUrls: ['./vertical-menu.component.scss'],
    animations: [SlideInOutRightAnimation, SlideInOutLeftAnimation],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ApVerticalNavigationItemComponent, ApVerticalSubmenuComponent, ApContentPipe]
})
export class ApVerticalMenuComponent {
    /**
     * The navigation items
     */
    public readonly navigationItems = input<NavigationItem[]>([]);

    /**
     * Is user logged in?
     * If not set no login will be shown.
     * If false login-button will be shown.
     * If true logged in state will be shown
     */
    public readonly isLoggedIn = input<boolean>();

    /**
     * Emits event if navigation is clicked
     */
    public readonly navigationClicked = output<NavigationItem>();

    /**
     * Emits event to login
     */
    public readonly loginLogout = output<boolean>();

    public subMenuItem: NavigationItem = null;

    private overflowXValue: string;

    // public toggleSubMenuItem(item?: NavigationItem): void {
    //     this.subMenuItem = this.subMenuItem ? null : item;
    // }

    private activeElement: string;

    public toggleSubMenuItem(item?: NavigationItem): void {
        if (item) {
            this.activeElement = (document.activeElement as HTMLElement).getAttribute('aria-label');
        } else {
            requestAnimationFrame(() => {
                (
                    document.querySelector(
                        `[aria-label="${this.activeElement}"] button, [aria-label="${this.activeElement}"]`
                    ) as HTMLElement
                )?.focus();
            });
        }
        this.subMenuItem = this.subMenuItem ? null : item;
    }

    public getNavigationItems() {
        return this.navigationItems().filter((d) => d.type !== NavigationType.SEARCH);
    }

    public navigate(navigationItem: NavigationItem): void {
        if (navigationItem.children) {
            this.toggleSubMenuItem(navigationItem);
        } else {
            this.navigationClicked.emit(navigationItem);
        }
    }

    /* istanbul ignore next */
    public disableOverflowX() {
        this.overflowXValue = this.getOverflowX();
        this.setOverflowX('hidden');
    }

    /* istanbul ignore next */
    public enableOverflowX() {
        this.setOverflowX(this.overflowXValue);
    }

    /* istanbul ignore next */
    private getOverflowX(): string {
        return document.querySelector('body').style.overflowX;
    }

    /* istanbul ignore next */
    private setOverflowX(style: string): void {
        document.querySelector('body').style.overflowX = style;
    }
}
